import React from 'react';

import { usePageDataContext } from '../../../../context/PageData';

import { Column } from '../../../Layout';
import Link from '../../../Link';

import {
  AppBadgeContainer,
  AppBadgeLayout,
  GoogleAppColumn,
  AmazonAppColumn,
  SpacerColumn,
  AppBadge
} from './styles';

import apple from '@/images/app-store-badge-white.svg';
import google from '@/images/google-play-badge-white.svg';
import amazon from '@/images/amazon-store-badge-white.svg';

export function AppLinks() {
  const { config } = usePageDataContext();

  const { appleAppLink, googleAppLink, amazonAppLink } = config ?? {};

  const badgeCount = [appleAppLink, googleAppLink, amazonAppLink].filter(
    (i) => i
  );

  return (
    <AppBadgeContainer
      id="app-block"
      marginTop={{ 0: 'm', desktop: 'ml' }}
      revealOnScroll={false}
    >
      <AppBadgeLayout gutter={{ 0: 'm', desktop: 's' }} id="app-link-layout">
        {appleAppLink && (
          <Column
            size={{
              0: badgeCount.length > 2 ? 12 : 6,
              tablet: badgeCount.length > 2 ? 4 : 6,
              desktop: 4
            }}
            justifyContent="center"
          >
            <Link href={appleAppLink} data-testid="ios-app-link">
              <AppBadge
                src={apple}
                alt="Download on the App Store"
                badgeCount={badgeCount.length}
              />
            </Link>
          </Column>
        )}
        {googleAppLink && (
          <GoogleAppColumn
            size={{ 0: 6, tablet: badgeCount.length > 2 ? 4 : 6, desktop: 4 }}
            badgeCount={badgeCount.length}
          >
            <Link href={googleAppLink} data-testid="android-app-link">
              <AppBadge
                src={google}
                alt="Get it on Google Play"
                badgeCount={badgeCount.length}
              />
            </Link>
          </GoogleAppColumn>
        )}
        {amazonAppLink && (
          <AmazonAppColumn
            size={{ 0: 6, tablet: badgeCount.length > 2 ? 4 : 6, desktop: 4 }}
            badgeCount={badgeCount.length}
          >
            <Link href={amazonAppLink} data-testid="amazon-app-link">
              <AppBadge
                src={amazon}
                alt="Get it on the Amazon App Store"
                badgeCount={badgeCount.length}
              />
            </Link>
          </AmazonAppColumn>
        )}
        <SpacerColumn
          size={badgeCount.length === 1 ? 8 : 4}
          hidden={badgeCount.length > 2}
        />
      </AppBadgeLayout>
    </AppBadgeContainer>
  );
}
